import React, { Component } from 'react';
import MerchantSingle from '../MerchantSingle/MerchantSingle';

class MerchantList extends Component {

    renderItems(merchants) {
        return merchants.map((merchant) => (
            <MerchantSingle key={merchant.id} merchant={merchant}/>
        ));
    }
    
    render() {
        var merchants = this.props.data ? this.props.data.merchants : [];

        return (  
            <div className="merchant-list">
                {this.renderItems(merchants)}
            </div>
        );
    }
}

export default MerchantList;



// WEBPACK FOOTER //
// ./src/components/MerchantList/MerchantList.js